export type SearchDocumentRequest = {
  searchTerm?: string;
  caseId?: number;
  beneId?: number;
  includeProfileDoc: boolean;
  isDocGen?: boolean;
  documentKeys?: string;
  orderBy?: string;
  sortOrder?: number;
  pageNumber?: number;
  pageSize?: number;
};

export type DocumentResponse = {
  id: string;
  documentApiKey: string;
  createdEpochTime: number;
  updatedEpochTime: number;
  version: number;
  beneficiaryId: number;
  documentName: string;
  documentType: string;
  documentNameAndType: string;
  uploadedBy: string;
  uploadDate: string;
  createdBy: number;
  createdByName: string;
  files: string[];
  documentVisibility: string;
  isLocked: boolean;
  lockedById: number;
  isRemote?: boolean;
  isImmigrationDocDraft?: boolean;
};

export type BeneDocsPaginatedResponse<T> = {
  pageNumber: number;
  pageSize: number;
  total: number;
  results: T[];
};

export interface IMessage {
  id?: string;
  internalId?: string;
  topic?: string;
  type?: string;
  origin?: string;
  content?: IMessageContent;
  RaisedBy?: string;
  raisedAt?: number;
}

export interface IMessageContent {
  id?: string;
  internalId?: string;
  name?: string;
}

export const UploadRequestStatuses = {
  Failed: 'Failed',
  Queued: 'Queued',
  Completed: 'Completed',
};

export interface DocumentData {
  docId: number;
  caseId: any;
  beneId: any;
  docTypeId: number;
  docTypeName: any;
  beneFullName: any;
  docName: string;
  country: any;
  files: string[];
  userTypes: string[];
  roles: string[];
  clientCaseIds: number[];
  fields: DocumentDataField;
  documentApiKey: string;
  companyId?: number;
  [key: string]: any;
}

export interface DocumentDataField {
  country?: string;
  hasEnoughBlanks?: boolean;
  isBiometric?: boolean;
  isTemporary?: boolean;
  issuedCity?: string;
  issuedDate?: string;
  issuedState?: string;
  issuedTo?: number;
  issuingAuthority?: string;
  locationOfPassport?: string;
  passportExpirationDate?: string;
  passportId?: number;
  passportIssuedCountry?: string;
  passportNumber?: string;
  passportType?: string;
}
